import Dropdown from "react-bootstrap/Dropdown";
import Sheet from "react-modal-sheet";
import translations from "../../translations/welcomeSheet.json";
import { useAppSelector } from "../../store/hooks";
import { selectUser } from "../../store/features/user";
import { getToken } from "../../backend/StorageUtils";
import { Translate, withLocalize } from "react-localize-redux";
import { Link } from "react-router-dom/cjs/react-router-dom";
import BaseButton from "wallet-elementkit/dist/elementKit/baseButton/BaseButton";

import SheetFooter from "../sheetFooter/SheetFooter";
import { langs } from "../../translations/translateJsonFile";
import "../../styles/components/welcomeSheet/welcomeSheetMobile.scss";
import { getMasterConfig } from "wallet-elementkit/dist/constants/master";
import { Subdomains } from "wallet-elementkit/dist/constants";

const WelcomeSheetMobile = (props) => {
	props.addTranslation(translations);
	const config = getMasterConfig();

	const userMeta = useAppSelector(selectUser);
	function checkLoggedIn() {
		return getToken() && userMeta && userMeta.logged;
	}

	function redirectToEmailVerify() {
		return checkLoggedIn() && !userMeta.isMailConfirmed;
	}
	return (
		<Sheet
			isOpen={props.sheetOpen}
			onClose={props.onClose}
			initialSnap={525}
			className="welcome-sheet-mobile"
		>
			<Sheet.Container>
				<Sheet.Header />
				<Sheet.Content>
					<div className="sheet-content-header">
						<span
							className="welcome-text"
							style={{
								marginTop: "15px",
								marginBottom: "29px",
							}}
						>
							<Translate
								id="welcomeDetailedText"
								data={{
									organizationName: config.organizationName,
								}}
							/>
						</span>
					</div>

					<div className="sheet-content-body flex-column ai-c">
						<div>
							<Link
								to={{
									pathname: `/${
										props.activeLanguage ? props.activeLanguage.code : "en"
									}/${redirectToEmailVerify() ? "verify-email" : "signup"}/`,
								}}
							>
								<BaseButton
									type="primary"
									size="large"
									height={55}
									width={245}
									loading={false}
									onClickAction={props.onClose}
								>
									<Translate id="signup" />
								</BaseButton>
							</Link>
							<Link
								to={`/${
									props.activeLanguage ? props.activeLanguage.code : "en"
								}/${redirectToEmailVerify() ? "verify-email" : "login"}/`}
							>
								<BaseButton
									type="primary"
									size="large"
									width={245}
									height={55}
									loading={false}
									styles={{ margin: "16px 0" }}
									onClickAction={props.onClose}
								>
									<Translate id="login" />
								</BaseButton>
							</Link>
						</div>

						{config.subDomain !== Subdomains.bitdefender && (
							<Dropdown
								id="dropdown-basic-button-mobile"
								onSelect={(langCode) => {
									props.changeLang(langCode);
								}}
							>
								<Dropdown.Toggle>
									<BaseButton
										type="secondary"
										size="large"
										height={55}
										loading={false}
										width={245}
									>
										<span>
											{props.activeLanguage ? props.activeLanguage.name : ""}
										</span>
									</BaseButton>
								</Dropdown.Toggle>
								<Dropdown.Menu>
									{langs.certificateLanguages.map((language) => (
										<Dropdown.Item eventKey={language.code} key={language.code}>
											{language.name}
										</Dropdown.Item>
									))}
								</Dropdown.Menu>
							</Dropdown>
						)}
					</div>
					{config.subDomain !== Subdomains.bitdefender && (
						<div className="sheet-content-footer flex-column ai-c">
							<SheetFooter />
						</div>
					)}
				</Sheet.Content>
			</Sheet.Container>
			<Sheet.Backdrop />
		</Sheet>
	);
};

export default withLocalize(WelcomeSheetMobile);
